var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'backbone', 'core', 'model/base', 'model/file', 'component/tax-calculator', 'common/component/money-formatter', 'common/location'], function($, _, Backbone, core, BaseModel, FileModel, taxCalculator, moneyFormatter, location) {
  /*
  # Work with transactions (dataEntries) is built with using index of the transactions array instead of real id.
  # This approach solves problem with creating document (when all IDs are nulls)
  */

  var DocumentModel;
  return DocumentModel = (function(_super) {

    __extends(DocumentModel, _super);

    function DocumentModel() {
      DocumentModel.__super__.constructor.apply(this, arguments);
    }

    DocumentModel.prototype.pathRoot = core.getConfig().apiPrefix + 'document.json';

    DocumentModel.prototype.defaults = function() {
      var _ref;
      return {
        id: null,
        clientId: core.getCurrentClientId(),
        fileId: null,
        file: null,
        vendor: '',
        attributes: {},
        documentDate: new Date().toString('MM/dd/yyyy'),
        currencyId: typeof core.getDefaultCurrency === "function" ? core.getDefaultCurrency().id : void 0,
        notes: '',
        currencyExchangeRate: null,
        dataEntries: [
          {
            id: null,
            ledgerAccountId: (typeof core.getDefaultLedgers === "function" ? (_ref = core.getDefaultLedgers()['pending.category.expense']) != null ? _ref.id : void 0 : void 0) || null,
            amount: 0,
            foreignAmount: null,
            entryType: 'DEBIT'
          }
        ],
        documentType: 'RECEIPT',
        expenseRevenueType: {
          value: 'Expense'
        },
        canChangeFinancialDocumentType: true,
        canApplyUnlink: false,
        hasUnlinkHistory: false,
        relatedJE: null,
        salesTaxApplicationStatus: 'NOT_APPLICABLE',
        amount: 0,
        taxAmount: null,
        internalNotes: []
      };
    };

    DocumentModel.prototype.start = function() {
      this.on('recalculate change:currencyId', this.recalculateTransactions, this);
      this.on('change:file', this.updateFile, this);
      return this.trigger('init');
    };

    DocumentModel.prototype.computeValues = function() {
      this.updateFile();
      this.updateTaxAmount();
      this.recalculateAmount();
      return this.trigger('computedValuesDone');
    };

    DocumentModel.prototype.init = function(fetch) {
      var _this = this;
      if (fetch == null) {
        fetch = true;
      }
      this.on('change', this.computeValues, this);
      if (this.get('id') != null) {
        if (fetch === true) {
          this.once('sync', function() {
            return _this.start();
          });
          this.once('error', function() {
            return _this.trigger('init.error');
          });
          return this.fetch();
        } else {
          this.computeValues();
          return this.start();
        }
      } else {
        return this.start();
      }
    };

    DocumentModel.prototype.deleteFile = function() {
      this.set('file', null);
      this.set('fileId', null);
      return this.save();
    };

    DocumentModel.prototype.updateFile = function() {
      var file, fileId,
        _this = this;
      file = this.get('file');
      fileId = this.get('fileId');
      if (file && _.isObject(file) && !(file instanceof FileModel)) {
        return this.set('file', new FileModel(file, {
          silent: true
        }));
      } else if (fileId && !file) {
        file = new FileModel({
          id: fileId
        });
        return file.fetch({
          success: function() {
            return _this.set('file', file);
          }
        });
      }
    };

    DocumentModel.prototype.updateTaxAmount = function() {
      var amount, taxAmount, _ref;
      if (this.isTaxApplied()) {
        amount = (_ref = _.find(this.get('dataEntries'), function(entry) {
          var ledgerCode, _ref1;
          ledgerCode = (_ref1 = core.getLedgersById()[entry.ledgerAccountId]) != null ? _ref1.code : void 0;
          return taxCalculator.isTaxLedgerCode(ledgerCode);
        })) != null ? _ref.amount : void 0;
        if (amount != null) {
          taxAmount = moneyFormatter.formatNumber(Math.abs(parseFloat(amount)));
          return this.set('taxAmount', taxAmount, {
            silent: true
          });
        } else {
          return this.set('taxAmount', null, {
            silent: true
          });
        }
      } else {
        return this.set('taxAmount', null, {
          silent: true
        });
      }
    };

    DocumentModel.prototype.recalculateAmount = function() {
      var ledgers, total;
      ledgers = this.getLedgers().debit;
      total = 0;
      ledgers.forEach(function(ledger) {
        return total += ledger.amount;
      });
      return this.set('amount', total);
    };

    DocumentModel.prototype.unlink = function() {
      return this.customCall('/unlink', 'PUT');
    };

    DocumentModel.prototype.previewUnlink = function() {
      return this.customCall('/preview_unlink', 'GET');
    };

    DocumentModel.prototype.applySalesTax = function() {
      return this.customCall('/applySalesTax', 'PUT');
    };

    DocumentModel.prototype.unapplySalesTax = function() {
      return this.customCall('/unapplySalesTax', 'PUT');
    };

    DocumentModel.prototype.clearUnlinkHistory = function() {
      return this.customCall('/clear_unlink_history', 'PUT');
    };

    DocumentModel.prototype.getCurrency = function() {
      return _.findWhere(core.getCollection('currencies').toJSON(), {
        id: this.get('currencyId')
      });
    };

    DocumentModel.prototype.validate = function(attrs) {
      var balance, errors, field, maxDate, testedDate, transaction, _i, _len, _ref, _ref1, _ref2;
      errors = {};
      maxDate = Date.today().add(1).days().clearTime().getTime();
      testedDate = Date.parse(attrs.documentDate).clearTime().getTime();
      if (((_ref = attrs.documentType) === 'RECEIPT' || _ref === 'TRANSACTIONAL') && !attrs.vendor) {
        errors.vendor = 'Vendor should not be empty';
      }
      if (((_ref1 = attrs.documentType) === 'TAX' || _ref1 === 'EXPORTS' || _ref1 === 'OTHER') && !attrs.attributes.name) {
        errors.name = 'Name should not be empty';
      }
      if (testedDate > maxDate) {
        field = attrs.documentType === 'STATEMENT' ? 'closingDate' : 'documentDate';
        errors[field] = 'Future dates are not allowed';
      }
      if (attrs.documentType === 'STATEMENT' && _.isEmpty(attrs.attributes.ledgerAccountId)) {
        errors.ledgers = 'Ledger account name cannot be empty';
      }
      if (attrs.documentType === 'PAYROLL_REPORT' && _.isEmpty(attrs.attributes.documentAddOnId)) {
        errors.documentAddOns = 'Add-on name cannot be empty';
      }
      if (attrs.documentType === 'PAYROLL_REPORT' && _.isEmpty(attrs.documentType)) {
        errors.addOnDocumentType = 'Document type cannot be empty';
      }
      if (attrs.documentType === 'TRANSACTIONAL' && attrs.dataEntries.length < 2) {
        errors.dataEntries = 'Document should have at least 2 transactions';
      }
      balance = Math.abs(this.getOutstandingBalance(attrs.dataEntries));
      if (attrs.documentType === 'TRANSACTIONAL' && balance > 0.001) {
        errors.balance = 'The debits and credits don\'t match';
      }
      if (attrs.documentType === "RECEIPT" && balance === 0) {
        errors.balance = 'Receipt should have a non-zero sum value';
      }
      _ref2 = attrs.dataEntries;
      for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
        transaction = _ref2[_i];
        if (!this.isCorrectAmount(transaction.amount)) {
          errors.balance = 'Incorrect amount';
        }
      }
      if (!_.isEmpty(errors)) {
        return errors;
      }
    };

    /*
    # Correct format: number[point][two-decimal-parts]
    # For example, correct:
    # 123
    # 123.1
    # 123.12
    */


    DocumentModel.prototype.isCorrectAmount = function(value) {
      return _.isNumber(value) && !_.isNaN(value) && !!Math.abs(value).toString().match(/^([0-9]*)(\.([0-9]{1,2}))?$/);
    };

    DocumentModel.prototype._requiredTransactionProperties = ['id', 'ledgerAccountId', 'amount', 'foreignAmount', 'entryType'];

    DocumentModel.prototype._transactionHasIntegrity = function(transaction) {
      var foundLedger, property, _i, _len, _ref;
      if (!_.isObject(transaction)) {
        return false;
      }
      _ref = this._requiredTransactionProperties;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        property = _ref[_i];
        if (typeof transaction[property] === 'undefined') {
          return false;
        }
      }
      foundLedger = _.findWhere(core.getCollection('ledgerAccounts').toJSON(), {
        id: transaction.ledgerAccountId
      });
      if ((transaction.ledgerAccountId != null) && (foundLedger == null)) {
        return false;
      }
      if ((transaction.amount != null) && !_.isNumber(transaction.amount)) {
        return false;
      }
      if ((transaction.foreignAmount != null) && !_.isNumber(transaction.foreignAmount)) {
        return false;
      }
      return true;
    };

    DocumentModel.prototype.addTransaction = function(transaction, index) {
      var transactions;
      if (!this._transactionHasIntegrity(transaction)) {
        throw new Error('Incorrect transaction object');
      }
      transactions = this.get('dataEntries');
      if (index != null) {
        transactions.splice(index, 0, transaction);
      } else {
        transactions.push(transaction);
      }
      this.set('dataEntries', transactions);
      return this.trigger('transaction.added', transaction);
    };

    DocumentModel.prototype.deleteTransaction = function(index) {
      var transactions;
      transactions = this.get('dataEntries');
      transactions.splice(index, 1);
      this.set('dataEntries', transactions);
      return this.trigger('transaction.deleted', index);
    };

    DocumentModel.prototype.clearTransactions = function() {
      return this.set('dataEntries', []);
    };

    DocumentModel.prototype.updateTransactionAmount = function(index, amount, type, foreign, errorCallback) {
      var absAmount, field, transaction, transactions;
      if (foreign == null) {
        foreign = false;
      }
      field = foreign ? 'foreignAmount' : 'amount';
      absAmount = Math.abs(amount);
      transactions = this.get('dataEntries');
      transaction = transactions[index];
      if (!this.isCorrectAmount(amount)) {
        if (errorCallback != null) {
          errorCallback(transaction[field]);
        }
        return;
      }
      transaction[field] = type === 'credit' ? -absAmount : absAmount;
      transaction.entryType = type.toUpperCase();
      this.set('dataEntries', transactions);
      if (foreign) {
        return this.recalculateTransactions();
      }
    };

    DocumentModel.prototype.updateTransactionLedger = function(index, ledgerId) {
      var transaction, transactions;
      transactions = this.get('dataEntries');
      transaction = transactions[index];
      transaction.ledgerAccountId = ledgerId.toString();
      return this.set('dataEntries', transactions);
    };

    DocumentModel.prototype._getSum = function(type, transactions) {
      var sum, transaction, _i, _len;
      if (transactions == null) {
        transactions = this.get('dataEntries');
      }
      sum = 0;
      for (_i = 0, _len = transactions.length; _i < _len; _i++) {
        transaction = transactions[_i];
        if (transaction.entryType === type) {
          sum += transaction.amount;
        }
      }
      return sum;
    };

    DocumentModel.prototype.getDebitsSum = function(transactions) {
      return this._getSum('DEBIT', transactions);
    };

    DocumentModel.prototype.getCreditsSum = function(transactions) {
      return this._getSum('CREDIT', transactions);
    };

    DocumentModel.prototype.getOutstandingBalance = function(transactions) {
      return this.getDebitsSum(transactions) + this.getCreditsSum(transactions);
    };

    DocumentModel.prototype._increaseFirstDebit = function(increment) {
      return this._increaseFirstTransactionAmount(increment, 'DEBIT');
    };

    DocumentModel.prototype._increaseFirstCredit = function(increment) {
      return this._increaseFirstTransactionAmount(increment, 'CREDIT');
    };

    DocumentModel.prototype._increaseFirstTransactionAmount = function(increment, type) {
      var transaction, transactions;
      transactions = this.get('dataEntries');
      transaction = _.findWhere(transactions, {
        entryType: type
      });
      transaction.amount = Math.round((transaction.amount + increment) * 100) / 100;
      return this.set('dataEntries', transactions);
    };

    DocumentModel.prototype.recalculateTransactions = function() {
      var absBalance, balance, currentCurrencyId, defaultCurrencyId, exchangeRate, transaction, transactions, _i, _j, _len, _len1;
      defaultCurrencyId = typeof core.getDefaultCurrency === "function" ? core.getDefaultCurrency().id : void 0;
      currentCurrencyId = this.get('currencyId');
      transactions = this.get('dataEntries');
      exchangeRate = this.get('currencyExchangeRate');
      if (defaultCurrencyId !== currentCurrencyId) {
        for (_i = 0, _len = transactions.length; _i < _len; _i++) {
          transaction = transactions[_i];
          if (transaction.foreignAmount == null) {
            transaction.foreignAmount = transaction.amount;
          }
          transaction.amount = Math.round(transaction.foreignAmount * exchangeRate * 100) / 100;
        }
      } else {
        for (_j = 0, _len1 = transactions.length; _j < _len1; _j++) {
          transaction = transactions[_j];
          if (transaction.foreignAmount != null) {
            transaction.amount = transaction.foreignAmount;
          }
          transaction.foreignAmount = null;
        }
      }
      this.set('dataEntries', transactions);
      balance = this.getOutstandingBalance();
      absBalance = Math.abs(balance);
      if (balance !== 0 && absBalance < 0.02) {
        if (balance < 0) {
          this._increaseFirstDebit(absBalance);
        }
        if (balance > 0) {
          this._increaseFirstCredit(-absBalance);
        }
      }
      return this.trigger('transactions.recalculated');
    };

    DocumentModel.prototype.canDeleteCauseConflict = function() {
      var ledger, transaction, transactions, _i, _len;
      transactions = this.get('dataEntries');
      for (_i = 0, _len = transactions.length; _i < _len; _i++) {
        transaction = transactions[_i];
        ledger = _.findWhere(core.getCollection('ledgerAccounts').toJSON(), {
          id: transaction.ledgerAccountId
        });
        if (ledger.canDeleteCauseConflict) {
          return ledger;
        }
      }
      return false;
    };

    DocumentModel.prototype.getHistory = function() {
      return apiCall("document", "" + (this.get('id')) + "/jeHistory", "GET");
    };

    DocumentModel.prototype.getLedgers = function() {
      var credit, debit, getLedgerName, model;
      model = this.toJSON();
      getLedgerName = function(dataEntry) {
        var _ref;
        dataEntry.ledgerName = ((_ref = core.getLedgersById()[dataEntry.ledgerAccountId]) != null ? _ref.name : void 0) || '';
        return dataEntry;
      };
      credit = _(model.dataEntries).filter(function(dataEntry) {
        return dataEntry.entryType === 'CREDIT';
      }).map(getLedgerName);
      debit = _(model.dataEntries).filter(function(dataEntry) {
        return dataEntry.entryType === 'DEBIT';
      }).map(getLedgerName);
      return {
        credit: credit,
        debit: debit
      };
    };

    DocumentModel.prototype.isTaxApplicable = function() {
      var status;
      status = this.get('salesTaxApplicationStatus');
      return (status != null) && status !== "NOT_APPLICABLE";
    };

    DocumentModel.prototype.isTaxApplied = function() {
      return this.get('salesTaxApplicationStatus') === 'APPLIED';
    };

    return DocumentModel;

  })(BaseModel);
});
